//-------------------------------
// calc unadjusted current skill
//-------------------------------
export default function calcUnadjCurrentSkill(parm) {
  // console.log('---------------------------------')
  // console.log('IN calcUnadjCurrentSkill')

  const base = Number(parm.base) || 0
  const ticks = Number(parm.ticks) || 0
  const training = Number(parm.training) || 0

  // console.log('base = ', base)
  // console.log('ticks = ', ticks)
  // console.log('training = ', training)

  const cur = base + ticks + training
  return cur < 0 ? 0 : Math.floor(cur)
}
